import { Box } from "@mui/material";
import TkLabelText from "../../../TkLabelText";
import { TkRadioGroup } from "../../../TkRadioGroup";
import { useContext, useEffect, useState } from "react";
import TkPropertyMessageGet from "../../../../../utils/TkPropertyMessageGet";
import { TkFormContext } from "../../../../../context/tkFormContext";
import { TkRadioGroupProps } from "../../../../../type/componentsType/TkRadioGroup";
import { ITkTextFieldProps } from "../../../../../type/componentsType/TkLabelText";

/**
 * テキストエリア付きラジオボタン部品
 * @param props
 * @returns RadioWithTextArea
 */
const RadioWithTextArea: React.FC<TkRadioGroupProps & ITkTextFieldProps> = (
  props
) => {
  const {
    onChange,
    onGetValue,
    radioPropsList,
    disabled,
    errorMessage,
    wantToSetValue,
    inputProps,
  } = props;
  const [isShow, setIsShow] = useState(false);
  const [clicked, setClicked] = useState(false);
  const [fieldValue, setFieldValue] = useState<{
    selectValue?: any;
    inputValue?: any;
  }>({});
  const [errorMsg, setErrorMsg] = useState("");
  const { formContext, setFormContext } = useContext(TkFormContext);

  useEffect(() => {
    if (wantToSetValue) {
      if (!Object.values(wantToSetValue)?.some((i) => i)) {
        onChange && onChange(undefined);
        return;
      }
      if (wantToSetValue.inputValue) {
        setIsShow(true);
      }

      setFieldValue(wantToSetValue);
      onChange && onChange(wantToSetValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantToSetValue]);

  const handleClick = (e: any) => {
    const value = e.target.value;
    if (value === fieldValue.selectValue && clicked) {
      onChange && onChange(undefined);
      return;
    }

    const newValue = { ...fieldValue, selectValue: value };
    if (value === radioPropsList[radioPropsList.length - 1].value) {
      setIsShow(true);
    } else {
      delete newValue.inputValue;
      setIsShow(false);
    }

    setFieldValue(newValue);
    onChange && onChange(newValue);
    onGetValue && onGetValue(newValue);
  };

  const handleChange = (e: any) => {
    const value = e.target.value;
    // eslint-disable-next-line no-control-regex
    if (!value.match(/^([^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ])*$/)) {
      setErrorMsg(TkPropertyMessageGet("TKMSG_SCR0061E"));
      setFormContext({
        preventSubmit: {
          ...formContext.preventSubmit,
          radioWithTextArea: true,
        },
      });
      return;
    } else if (value.length > inputProps?.maxLength) {
      setErrorMsg(
        TkPropertyMessageGet("TKMSG_SCR0046E", inputProps?.maxLength)
      );
      setFormContext({
        preventSubmit: {
          ...formContext.preventSubmit,
          radioWithTextArea: true,
        },
      });
      return;
    }
    setErrorMsg("");
    setFormContext({
      preventSubmit: { ...formContext.preventSubmit, radioWithTextArea: false },
    });

    const newValue = { ...fieldValue, inputValue: value };

    setFieldValue(newValue);
    onChange && onChange(newValue);
    onGetValue && onGetValue(newValue);
  };

  return (
    <Box className="radioWithTextArea">
      <TkRadioGroup
        radioPropsList={radioPropsList}
        wantToSetValue={wantToSetValue?.selectValue}
        onClick={handleClick}
        onChange={(e: any) => setClicked(!!e)}
        disabled={disabled}
        errorMessage={errorMessage}
      />
      {isShow && (
        <TkLabelText
          fullWidth
          onChange={handleChange}
          wantToSetValue={wantToSetValue?.inputValue}
          inputProps={inputProps}
          error={!!errorMsg}
          helperText={errorMsg}
          disabled={disabled}
        />
      )}
    </Box>
  );
};

export default RadioWithTextArea;
